"use client";

import { Core } from "@faire/design-tokens";
import { Row, VerticalLine } from "@faire/web--source/slate/Layout";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";

import { Color } from "../Color";
import {
  highVisSlateComponent,
  HIGH_VIS_FILTER,
} from "../utils/highVisSlateComponent";

import { StatusBadgeProps } from "./types";

export const StatusBadge: React.FC<StatusBadgeProps> = (props) => {
  const {
    backgroundColor,
    borderColor,
    borderRadius,
    content,
    contentColor = Core.text.default,
    prefix,
  } = props;

  const border = borderColor ? `1px solid ${borderColor}` : "none";
  const dividerColor = props.dividerColor ?? contentColor ?? Core.border.muted;

  return (
    <StatusBadgeWrapper
      $backgroundColor={backgroundColor}
      $border={border}
      $borderRadius={borderRadius}
      $contentColor={contentColor}
      data-test-id={props["data-test-id"]}
      className={props.className}
    >
      {prefix ? (
        <>
          {prefix}
          <VerticalLine $color={dividerColor} $margin="0 6px" $height="12px" />
        </>
      ) : null}
      {content}
    </StatusBadgeWrapper>
  );
};

const StatusBadgeWrapper = styled(Row).attrs({
  align: "center",
  justify: "center",
})<{
  $backgroundColor: Color;
  $border: string;
  $borderRadius: string | undefined;
  $contentColor: Color;
}>`
  ${(props) =>
    TypographyStyles({
      variant: "paragraphSansRegular",
      theme: props.theme,
    })};
  background-color: ${(props) => props.$backgroundColor};
  block-size: 24px;
  border: ${(props) => props.$border};
  border-radius: ${(props) => props.$borderRadius ?? "4px"};
  color: ${(props) => props.$contentColor};
  inline-size: fit-content;
  padding-inline: ${(props) => (props.$border === "none" ? "8px" : "7px")};
  white-space: nowrap;
  ${highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT)}
`;
